module.exports = __webpack_public_path__ + "static/16-1-42b15539d98b5c7e7e8928f83af38b1c.jpg";